// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__tyRz3","container":"styles_container__12f0T"};